// 吃瓜网爆 · 首页静态演示数据（仅用于单页展示，不含真实举报信息，人物均为演示拟名）

export const leadStory = {
  kicker: "今日头条 · 实锤集合",
  title: "顶流综艺导师与素人主播连麦露馅：连麦前说好的剪辑稿，被一句没关麦的闲聊全拆穿",
  excerpt:
    "前因后果一次摆清：节目组为冲热度给直播导师安排了“即兴连麦”剧本，可导播忘了关掉场控麦。一句“等会儿他要是答不上来你就顺着我稿子圆”被原声收录，随后秒切黑屏。网友逐帧对比三场连麦，时间轴、口型与字幕三处对不上，锤点已集中归档。",
  tags: ["实锤", "综艺塌房", "前因后果已理清"],
  meta: { hot: "3.8万 在吃", update: "今天 21:40", comments: 2641 },
  image:
    "https://readdy.ai/api/search-image?query=editorial%20backstage%20broadcast%20studio%20scene%20with%20a%20dim%20warm%20ambient%20lighting%2C%20silhouette%20of%20a%20host%20behind%20a%20microphone%20boom%20and%20mixing%20desk%2C%20subtle%20amber%20and%20cream%20tonal%20palette%2C%20cinematic%20television%20drama%20atmosphere%2C%20soft%20shadows%2C%20moody%20and%20mysterious%20editorial%20photography%2C%20high%20detail%2C%20clean%20composition&width=960&height=1180&seq=hero-lead-2026&orientation=portrait",
};

export const hotRanks = [
  { no: 1, title: "女团Selene 打歌舞台对口型穿帮", delta: "+1200", heat: "9.2 万" },
  { no: 2, title: "美食博主阿南 带货同款价差 3 倍实锤", delta: "+860", heat: "7.4 万" },
  { no: 3, title: "选秀回锅选手 出道前酒局照流出", delta: "+540", heat: "6.1 万" },
];

export const topicTags = [
  { text: "实锤集合", type: "primary" },
  { text: "新瓜速报", type: "plain" },
  { text: "对线现场", type: "plain" },
  { text: "价格虚标", type: "accent" },
  { text: "抄袭实锤", type: "plain" },
  { text: "旧料翻新", type: "plain" },
  { text: "塌房进行时", type: "primary" },
  { text: "人设崩塌", type: "plain" },
  { text: "直播翻车", type: "accent" },
  { text: "聊天记录", type: "plain" },
  { text: "录音流出", type: "plain" },
  { text: "营业翻车", type: "plain" },
  { text: "爽文预警", type: "primary" },
  { text: "网盘秒删", type: "plain" },
  { text: "复盘帖", type: "accent" },
  { text: "打脸现场", type: "plain" },
  { text: "前因后果", type: "plain" },
  { text: "延期实锤", type: "plain" },
];

export const evidenceItems = [
  {
    tag: "带货·价差",
    title: "阿南带货“同源”零食，实锤比旗舰店贵 3 倍",
    chain: ["上游发货单", "同批次货号", "比价录屏"],
    status: "已实锤",
    statusType: "ok",
    heat: "7.4万在吃",
    brief: "同一箱货标着两个渠道码，录屏三屏同录，物流轨迹指向同一云仓。",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20food%20delivery%20box%20and%20receipt%20flatlay%20on%20warm%20cream%20table%2C%20amber%20natural%20lighting%2C%20price%20tags%20and%20logistics%20label%20visible%2C%20honest%20product%20review%20newsroom%20style%2C%20soft%20shadows%2C%20muted%20warm%20tonal%20palette%2C%20high%20detail%20clean%20composition&width=800&height=640&seq=ev-goods-2026&orientation=squarish",
  },
  {
    tag: "对线·发公告",
    title: "某宠物品牌被指“报修单造假”，前员工放出排班表",
    chain: ["排班表", "维修工单", "后台截图"],
    status: "存疑跟进",
    statusType: "warn",
    heat: "5.2万在吃",
    brief: "品牌方口径与三份内部表对不上，目前只放出排班，工单还在追。",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20office%20schedule%20document%20and%20laptop%20with%20customer%20service%20chat%20on%20screen%2C%20warm%20desk%20lamp%20light%2C%20cream%20and%20amber%20tones%2C%20newsroom%20investigation%20mood%2C%20soft%20shadows%2C%20clean%20minimal%20composition%2C%20detailed%20still%20life&width=800&height=640&seq=ev-pet-2026&orientation=squarish",
  },
  {
    tag: "舞台·对口型",
    title: "女团Selene 打歌舞台口型与垫音错位 1.2 秒",
    chain: ["舞台直拍", "垫音波形", "帧对比"],
    status: "已实锤",
    statusType: "ok",
    heat: "9.2万在吃",
    brief: "三场直拍同一位置口型全错，垫音波形与鼓点对齐后仍差一拍。",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20backlit%20stage%20performance%20with%20spotlights%20and%20silhouette%20of%20dancers%2C%20warm%20amber%20and%20gold%20stage%20lights%2C%20hazy%20atmosphere%2C%20cinematic%20music%20show%20mood%2C%20cream%20and%20gold%20tonal%20palette%2C%20soft%20glow%2C%20high%20detail%20mysterious%20composition&width=800&height=640&seq=ev-stage-2026&orientation=squarish",
  },
  {
    tag: "旧料·翻新",
    title: "三年前“秒删”录音被重新拼出完整版：漏掉的 11 秒是关键",
    chain: ["原始录音", "时间轴", "第三方转写"],
    status: "已实锤",
    statusType: "ok",
    heat: "6.6万在吃",
    brief: "旧帖只剪了半句，网友把断点接回后，语境完全反过来，风评反转。",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20vintage%20audio%20recorder%20and%20worn%20paper%20transcript%20on%20warm%20wood%20desk%2C%20amber%20desk%20light%2C%20retro%20investigation%20mood%2C%20cream%20and%20brown%20tonal%20palette%2C%20soft%20shadows%2C%20detailed%20still%20life%20photography%2C%20clean%20composition&width=800&height=640&seq=ev-voice-2026&orientation=squarish",
  },
  {
    tag: "直播·翻车",
    title: "场控麦没关，直播导师的“帮粉丝问”话术被原声曝光",
    chain: ["原声收录", "三场连麦", "字幕对比"],
    status: "已实锤",
    statusType: "ok",
    heat: "8.8万在吃",
    brief: "“等会儿他答不上来你就顺稿圆”被现场收音，与剪辑口型对不上。",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20live%20streaming%20broadcast%20control%20room%20with%20multiple%20monitors%20and%20mixing%20desk%2C%20warm%20screen%20glow%20amber%20light%2C%20newsroom%20documentary%20mood%2C%20cream%20and%20warm%20grey%20tones%2C%20soft%20shadows%2C%20detailed%20clean%20composition&width=800&height=640&seq=ev-live-2026&orientation=squarish",
  },
  {
    tag: "人设·对比",
    title: "探店博主前后两期“穷游人设”，机票订单档期穿帮",
    chain: ["订单截图", "两期时间轴", "定位记录"],
    status: "存疑跟进",
    statusType: "warn",
    heat: "4.1万在吃",
    brief: "一期喊穷吃泡面，另一期同一天订了头等舱，票号对上了档期。",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20airplane%20boarding%20pass%20and%20budget%20noodle%20snack%20on%20airport%20table%20with%20warm%20window%20light%2C%20travel%20documentary%20mood%2C%20amber%20and%20cream%20tonal%20palette%2C%20soft%20shadows%2C%20contrast%20storytelling%2C%20high%20detail%20clean%20composition&width=800&height=640&seq=ev-travel-2026&orientation=squarish",
  },
];

export const personas = [
  { name: "阿南", role: "美食博主", status: "带货价差·已实锤", statusType: "ok", topics: 8 },
  { name: "Selene", role: "限定女团", status: "对口型·已实锤", statusType: "ok", topics: 5 },
  { name: "星途Studio", role: "综艺厂牌", status: "场控麦·已实锤", statusType: "ok", topics: 6 },
  { name: "木与栗宠物", role: "宠物品牌", status: "报修单·跟进中", statusType: "warn", topics: 3 },
  { name: "老饕探店", role: "探店博主", status: "人设对比·跟进中", statusType: "warn", topics: 4 },
  { name: "回锅少年R", role: "选秀选手", status: "旧照流出·存疑", statusType: "warn", topics: 2 },
  { name: "声浪文化", role: "MCN机构", status: "分成争议·待锤", statusType: "idle", topics: 3 },
  { name: "顶流导师L", role: "综艺导师", status: "连麦翻车·已实锤", statusType: "ok", topics: 7 },
];

export const collections = [
  {
    title: "2026 上半年 · 带货翻车合集",
    subtitle: "价差、虚标、伪同源的集中档案",
    count: "12 条",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20magazine%20style%20collage%20cover%20with%20shopping%20receipts%20barcode%20and%20price%20labels%20stacked%2C%20warm%20cream%20background%2C%20amber%20lighting%2C%20catalogue%20index%20aesthetic%2C%20soft%20shadows%2C%20detailed%20clean%20graphic%20composition&width=760&height=920&seq=col-goods-2026&orientation=portrait",
  },
  {
    title: "舞台对口型 · 实锤清单",
    subtitle: "直拍、垫音波形与字幕逐条对应",
    count: "8 条",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20collage%20of%20concert%20spotlight%20and%20audio%20waveform%20printout%20on%20cream%20board%2C%20warm%20gold%20stage%20glow%2C%20index%20archive%20aesthetic%2C%20soft%20shadows%2C%20amber%20tonal%20palette%2C%20detailed%20clean%20graphic%20composition&width=760&height=920&seq=col-stage-2026&orientation=portrait",
  },
  {
    title: "选秀旧料 · 黑料大全",
    subtitle: "出道前旧照与聊天记录归到一个夹",
    count: "15 条",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20archive%20folder%20collage%20with%20old%20photo%20prints%20and%20chat%20bubbles%20on%20cream%20desk%2C%20dim%20warm%20light%2C%20scandal%20investigation%20archive%20mood%2C%20amber%20and%20brown%20tones%2C%20soft%20shadows%2C%20detailed%20clean%20graphic%20composition&width=760&height=920&seq=col-idol-2026&orientation=portrait",
  },
  {
    title: "综艺剧本 · 穿帮复盘",
    subtitle: "从场控麦到后期剪辑的口型时间轴",
    count: "9 条",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20storyboard%20pages%20and%20clapperboard%20collage%20on%20cream%20desk%2C%20warm%20studio%20amber%20light%2C%20variety%20show%20behind%20the%20scenes%20mood%2C%20soft%20shadows%2C%20clean%20index%20aesthetic%2C%20detailed%20composition&width=760&height=920&seq=col-show-2026&orientation=portrait",
  },
];

export const feedItems = [
  { time: "21:10", cat: "实锤", text: "Selene 三场直拍逐帧对比已上传，口型错位固定在同一拍。" },
  { time: "20:48", cat: "更新", text: "阿南带货帖补上同批次货号，第二家仓库比价也在路上。" },
  { time: "20:22", cat: "对线", text: "木与栗宠物就报修单发文，评论区放出的是前员工排班表。" },
  { time: "19:56", cat: "新瓜", text: "老饕探店两期机票订单一前一后，粉丝已按档期排好时间轴。" },
  { time: "19:31", cat: "实锤", text: "三年前“秒删”录音完整版拼出，漏掉的 11 秒让风评反转。" },
  { time: "19:05", cat: "更新", text: "顶流导师L 场控麦原声已分段标注，方便逐句对照字幕。" },
  { time: "18:40", cat: "新瓜", text: "回锅选手R 出道前酒局照流出，网友在核对同框人脸时间线。" },
  { time: "18:12", cat: "对线", text: "声浪文化就分成争议放结算单，主播方称还有第二份未公布。" },
  { time: "17:47", cat: "实锤", text: "带货“同源零食”比价录屏补齐第三屏，价差数据统一整理中。" },
  { time: "17:20", cat: "更新", text: "综艺剧本帖更新：连麦三场时间轴已合并，新增一处分镜证据。" },
  { time: "16:58", cat: "新瓜", text: "探店博主人设对比新截图流出，机票与泡面帖同日档期穿帮。" },
  { time: "16:30", cat: "旧料", text: "网友把去年被删的品牌售后帖捞回，补进报修单时间线。" },
];

export const hotComments = [
  {
    user: "吃瓜不站队",
    text: "把场控麦那段原声听三遍，再看字幕对不上的地方，真的会笑出声。整理得很清楚，前因后果一下就懂了。",
    likes: 893,
    replies: 47,
    role: "梳理担当",
  },
  {
    user: "只在瓜田蹲",
    text: "同源比价那个帖子真的绝，同箱货码都能标两个，等第二家仓库的账出来再补一刀。",
    likes: 621,
    replies: 31,
    role: "截图狂魔",
  },
  {
    user: "锤子得排队",
    text: "旧料翻新那段 11 秒才是关键，之前全网都带跑偏了，这一版时间轴才是完整故事。",
    likes: 447,
    replies: 23,
    role: "时间线厨",
  },
  {
    user: "路过的工具人",
    text: "按类码好真的省心，以前翻聊天记录翻到手腕疼，现在直接按人切过去看锤点就行。",
    likes: 305,
    replies: 18,
    role: "普通吃瓜",
  },
  {
    user: "别急先看锤",
    text: "报修单那个先别冲，等第二份排班出来再定性，免得被打脸。存疑的就该标存疑。",
    likes: 212,
    replies: 12,
    role: "理智派",
  },
];

export const navSections = [
  { label: "话题墙", href: "#topics" },
  { label: "实锤集合", href: "#shilu" },
  { label: "人物档案", href: "#renwu" },
  { label: "合集目录", href: "#heji" },
  { label: "实时快讯", href: "#kuaixun" },
  { label: "讨论区", href: "#luntan" },
];